
import Splash from "../Pages/Splash";
import Login from "../Pages/Auth/Login";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import Home from "../Pages/Home/Home";
import Register from "../Pages/Auth/Register";
import CreateVendor from "../Pages/Vendor/CreateVendor";
import ManagerVendor from "../Pages/Vendor/ManageVendor";
import OrderDetails from "../Pages/Home/OrderDetails";
import ManagerProducts from "../Pages/Vendor/ManageProducts";
import EditProduct from "../Pages/Vendor/EditProduct";
import InsertProduct from "../Pages/Vendor/InsertProduct";
import Content from "../Pages/Home/Content";
import SelectVendor from "../Pages/Vendor/SelectVendor";
import VendorProducts from "../Pages/Vendor/VendorProducts";
import EditProfile from "../Pages/Auth/EditProfile";
import VendorReports from "../Pages/Vendor/VendorReports";
import InviteLogin from "../Pages/Auth/InviteLogin";
import VendorProductReports from "../Pages/Vendor/VendorProductReports";
import SelectArea from "../Pages/Vendor/SelectArea";
import VendorProductsBatchEdit from "../Pages/Vendor/VendorProductsBatchEdit";
import Wallet from "../Pages/Home/Wallet";


const appRoutes = [
    {
        pageId : 1,
        path: "/",
        component: <Splash />,
    },
    {
        pageId : 2,
        path: "/login",
        component: <Login />,
    },
    {
        pageId : 3,
        path: "/register",
        component: <Register />,
    },
    {
        pageId : 4,
        path: "/verify",
        component: <VerifyOTP />,
    },
    {
        pageId : 5,
        path: "/home",
        component: <Home />,
    },
    {
        pageId : 51,
        path: "/home/:id",
        component: <Home />,
    },
    {
        pageId : 6,
        path: "/vendor/create",
        component: <CreateVendor />,
    },
    {
        pageId : 7,
        path: "/vendor/manage",
        component: <ManagerVendor />,
    },
    {
        pageId : 8,
        path: "/order/:id",
        component: <OrderDetails />,
    },
    {
        pageId : 9,
        path: "/products",
        component: <ManagerProducts />,
    },
    {
        pageId : 10,
        path: "/product/:id",
        component: <EditProduct />,
    },
    {
        pageId : 11,
        path: "/new-product",
        component: <InsertProduct />,
    },

    {
        pageId : 12,
        path: "/contents/:slug",
        component: <Content />,
    },

    {
        pageId : 13,
        path: "/vendor/select",
        component: <SelectVendor />,
    },
    {
        pageId : 14,
        path: "/vendor/:id/:oid",
        component: <VendorProducts />,
    },
    {
        pageId : 15,
        path: "/edit-profile",
        component: <EditProfile />,
    },
    {
        pageId : 16,
        path: "/reports",
        component: <VendorReports />,
    },
    {
        pageId : 17,
        path: "/product-reports",
        component: <VendorProductReports />,
    },
    {
        pageId : 18,
        path: "/invite/:code",
        component: <InviteLogin />,
    },
    {
        pageId : 19,
        path: "/select-area",
        component: <SelectArea />,
    },
    {
        pageId : 20,
        path: "/batch-edit",
        component: <VendorProductsBatchEdit />,
    },
    {
        pageId : 21,
        path: "/wallet",
        component: <Wallet />,
    },

];
export default appRoutes;